<template>
	<div class="wallet-page">
		<!-- 汇总 -->
		<div style="margin: 10px 0">
		截至目前：提成入账钱包金额 {{ allCount.commissionInAmount }}元，退费回补入账钱包金额{{
			allCount.refundInAmount
		}}元，提现成功总数{{ allCount.withdrawSuccessCount }}次，提现失败总数{{
			allCount.withdrawFailCount
		}}次
		</div>
		
		<!-- 标签页（增加tab-click事件，对齐提现统计的标签页结构） -->
		<el-tabs v-model="activeTab" @tab-click="changeSelectValue" type="card" class="tab-box">
			<!-- 钱包统计 -->
			<el-tab-pane label="钱包统计" name="stat">
				<!-- 查询区域（日期选择器v-model改为dateRange，对齐提现统计） -->
				<div class="query-row">
					<div class="query-item">
						<span>时间:</span>
						<el-date-picker
								v-model="statQuery.dateRange"
								type="daterange"
								range-separator="-"
								separator="至"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								clearable
						/>
					</div>
					<el-button type="primary" @click="getStatListFun">查询</el-button>
				</div>
				
				<!-- 统计表格（结构保持，仅变量对齐） -->
				<el-table
						:data="statList"
						border
						stripe
						header-align="center"
						align="center"
						size="medium"
				>
					<el-table-column label="系统日期" prop="dateTime" width="" header-align="center" align="center"></el-table-column>
					<el-table-column label="提成入账钱包" prop="pretaxAmount" width="" header-align="center" align="center">
						<template slot-scope="scope">
							<div class="color-green"  @click="jumpdetail" >{{ scope.row.pretaxAmount }}</div>
						</template>
					</el-table-column>
					<el-table-column label="退费回补入账钱包" prop="refundAmount" width="" header-align="center" align="center">
						<template slot-scope="scope">
							<span class="color-red" >{{ scope.row.refundAmount }}</span>
						</template>
					</el-table-column>
					<el-table-column label="提现成功" prop="withdrawSuccessAmount" width="" header-align="center" align="center">
						<template slot-scope="scope">
							<span class="color-red" >{{ scope.row.withdrawSuccessAmount }}</span>
						</template>
					</el-table-column>
					<el-table-column label="提现失败" prop="withdrawFailAmount" width="" header-align="center" align="center"></el-table-column>
<!--					<el-table-column label="操作" width="100">-->
<!--						<template slot-scope="scope">-->
<!--							<el-link type="primary" @click="viewStat(scope.row)">查看</el-link>-->
<!--						</template>-->
<!--					</el-table-column>-->
				</el-table>
				
				<!-- 统计分页（参数对齐：pageSize/pageNum，方法名对齐） -->
				<div class="pager-box">
					<span>共{{ statTotal }}条</span>
					<el-pagination
							:page-sizes="[20,50,100]"
							:page-size="statPage.pageSize"
							:current-page="statPage.pageNum"
							:total="statTotal"
							layout="sizes, prev, pager, next, jumper"
							@size-change="statSizeChange"
							@current-change="statPageChange"
					/>
				</div>
			</el-tab-pane>
			
			<!-- 钱包明细 -->
			<el-tab-pane label="钱包明细" name="detail">
				<!-- 查询区域（日期v-model改为dateRange，方法名对齐） -->
				<div class="query-row detail-query">
					<div class="query-item">
						<span>用户姓名:</span>
						<el-input v-model="detailQuery.userName" placeholder="请输入用户姓名" style="width:160px" clearable />
					</div>
					<div class="query-item">
						<span>手机号:</span>
						<el-input v-model="detailQuery.phone" placeholder="请输入手机号" style="width:160px" clearable />
					</div>
					<div class="query-item">
						<span>类型:</span>
						<el-select v-model="detailQuery.type" placeholder="全部" clearable style="width:120px">
							<el-option label="全部" value="all" ></el-option>
							<el-option label="提成转入" :value="1" ></el-option>
							<el-option label="手动提现" :value="2" ></el-option>
							<el-option label="自动提现" :value="3" ></el-option>
							<el-option label="提现失败退回" :value="4" ></el-option>
							<el-option label="退费回补" :value="5" ></el-option>
						</el-select>
					</div>
					<div class="query-item">
						<span>状态:</span>
						<el-select v-model="detailQuery.status" placeholder="全部" clearable style="width:120px">
							<el-option label="全部" value="all" ></el-option>
							<el-option label="已完成" :value="1" ></el-option>
							<el-option label="转账中" :value="2" ></el-option>
						</el-select>
					</div>
					
					<div class="query-item time-box">
						<span>时间:</span>
						<el-button size="mini" @click="setDay(-1)">前一天</el-button>
						<el-date-picker
								v-model="detailQuery.dateRange"
								type="daterange"
								range-separator="-"
								separator="至"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								clearable
								style="width:280px"
						/>
						<el-button size="mini" @click="setDay(1)">后一天</el-button>
					</div>
					
					<div class="query-item">
						<span>金额范围:</span>
						<el-input v-model="detailQuery.minAmt" placeholder="最小" style="width:100px" clearable />
						<span>-</span>
						<el-input v-model="detailQuery.maxAmt" placeholder="最大" style="width:100px" clearable />
					</div>
					
					<el-button type="primary" @click="resetDetailQuery">重置查询条件</el-button>
					<el-button type="primary" @click="getDetailListFun">查询</el-button>
				</div>
				
				<!-- 明细表格（结构保持） -->
				<el-table
						:data="detailList"
						border
						stripe
						header-align="center"
						align="center"
						class="data-table"
				>
<!--					<el-table-column prop="id" label="流水ID" width="100"></el-table-column>-->
<!--					<el-table-column prop="userQmxfId" label="用户ID" width="100"></el-table-column>-->
					<el-table-column prop="nickName" label="用户名称" width="" header-align="center" align="center"></el-table-column>
					<el-table-column prop="phoneNumber" label="手机号" width="" ></el-table-column>
<!--					<el-table-column prop="walletId" label="钱包ID" width="100"></el-table-column>-->
					<el-table-column prop="walletBalance" label="钱包余额(元)" width="" header-align="center" align="center"></el-table-column>
					<el-table-column prop="bizType" label="业务类型" width="" header-align="center" align="center">
						<template slot-scope="scope">
							<div style="padding: 5px 10px;">{{ getBizTypeName(scope.row.bizType) }}</div>
						</template>
					</el-table-column>
<!--					<el-table-column prop="relevanceId" label="关联ID" width="100"></el-table-column>-->
					<el-table-column prop="amount" label="变动金额(元)" width="" header-align="center" align="center">
						<template slot-scope="scope">
              <span :class="scope.row.amount > 0 ? 'text-success' : 'text-danger'">
                {{ scope.row.amount }}
              </span>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="状态" width="" header-align="center" align="center">
						<template slot-scope="scope">
							<el-tag
									:type="scope.row.status == '1' ? 'success' : 'warning'"
									size="small"
							>
								{{ scope.row.status == '1' ? '已完成' : '转账中' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="createTime" label="系统时间" width="" header-align="center" align="center"></el-table-column>
					<el-table-column prop="updateTime" label="更新时间" width="" header-align="center" align="center"></el-table-column>
<!--					<el-table-column prop="remark" label="备注" min-width="150"></el-table-column>-->
				</el-table>
				
				<!-- 明细分页（参数对齐：pageSize/pageNum，方法名对齐） -->
				<div class="pager-box">
					<span>共{{ detailTotal }}条</span>
					<el-pagination
							:page-sizes="[20,50,100]"
							:page-size="detailPage.pageSize"
							:current-page="detailPage.pageNum"
							:total="detailTotal"
							layout="sizes, prev, pager, next, jumper"
							@size-change="detailSizeChange"
							@current-change="detailPageChange"
					/>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
// 引入后台接口（请根据实际项目的接口路径调整）
import {
	 getWebUserQmxfWalletRecordsListPageCount, getWebUserQmxfWalletRecordsListPage,getWalletSummary
} from "../../api/api";
// 导入全局回车搜索功能
import { useEnterSearch, removeEnterSearch } from '../../../util/enterSearch';

export default {
	name: 'WalletPage',
	data() {
		return {
			// 当前激活标签（对齐提现统计）
			activeTab: "stat",
			// 总条数（初始化为0，从接口获取，对齐提现统计）
			statTotal: 0,
			detailTotal: 0,
			
			// ============= 钱包统计 =============
			statQuery: {
				dateRange: "" // 对齐提现统计的日期字段名
			},
			statPage: {
				pageNum: 1, // 替换原page为pageNum
				pageSize: 20 // 替换原size为pageSize
			},
			statList: [], // 清空模拟数据，从接口获取
			
			// ============= 钱包明细 =============
			detailQuery: {
				userName: '',
				phone: '',
				type: 'all',
				status: 'all',
				dateRange: "", // 替换原date为dateRange
				minAmt: '',
				maxAmt: ''
			},
			detailPage: {
				pageNum: 1, // 替换原page为pageNum
				pageSize: 20 // 替换原size为pageSize
			},
			detailList: [], // 清空模拟数据，从接口获取
			// 业务类型映射（方便渲染）
			bizTypeMap: {
				'1': '提成转入',
				'2': '手动提现',
				'3': '自动提现',
				'4': '提现失败退回',
				'5': '退费回补'
			},
			allCount:""
		};
	},
	mounted() {
		// 使用全局回车搜索功能
		useEnterSearch(() => {
			if (this.activeTab === "stat") {
				this.statPage.pageNum = 1;
				this.statPage.pageSize = 20;
				this.getStatList();
			} else if (this.activeTab === "detail") {
				this.detailPage.pageNum = 1;
				this.detailPage.pageSize = 20;
				this.getDetailList();
			}
		});
	},
	beforeDestroy() {
		// 移除全局回车监听
		removeEnterSearch();
	},
	methods: {
		getWalletSummaryFun(){
			getWalletSummary().then(res=>{
				if(res.data.success){
					this.allCount = res.data.response
				}
			})
		},
		getDetailListFun(){
			this.detailPage.pageNum = 1;
			this.detailPage.pageSize = 20;
			this.getDetailList();
		},
		getStatListFun(){
			this.statPage.pageNum = 1;
			this.statPage.pageSize = 20;
			this.getStatList()
		},
		jumpdetail(){
			this.activeTab = "detail"
			this.detailQuery.dateRange = this.statQuery.dateRange;
			this.detailPage.pageNum = 1;
			this.detailPage.pageSize = 20;
			this.getDetailList();
		},
		// 业务类型名称转换
		getBizTypeName(bizType) {
			return this.bizTypeMap[bizType] || '未知类型'
		},
		// 切换标签页重新加载数据（对齐提现统计的changeSelectValue）
		changeSelectValue(value) {
			console.log('走切换标签了')
			if (value.name === "stat") {
				this.statPage.pageNum = 1;
				this.getStatList();
			} else if (value.name === "detail") {
				this.detailPage.pageNum = 1;
				this.getDetailList();
			}
		},
		
		// ========== 钱包统计 ==========
		async getStatList() {
			try {
				// 封装查询参数（对齐提现统计的参数结构）
				const params = {
					pageIndex: this.statPage.pageNum,
					pageSize: this.statPage.pageSize,
					// 拆分日期范围（对齐提现统计）
					startTime: this.statQuery.dateRange ? this.statQuery.dateRange[0] : '',
					endTime: this.statQuery.dateRange ? this.statQuery.dateRange[1] : ''
				};
				
				// 调用钱包统计接口
				const res = await getWebUserQmxfWalletRecordsListPageCount(params);
				
				if (res.data.success) {
					this.statList = res.data.response.data;
					this.statTotal = res.data.response.dataCount;
					// this.$message.success("钱包统计查询成功");
				} else {
					this.$message.error(res.data.message || "钱包统计查询失败");
				}
			} catch (error) {
				console.error("钱包统计查询异常：", error);
				this.$message.error("网络异常，钱包统计查询失败");
			}
			
		},
		// 统计分页大小变化（对齐提现统计）
		statSizeChange(val) {
			this.statPage.pageSize = val;
			this.getStatList();
		},
		// 统计分页页码变化（对齐提现统计）
		statPageChange(val) {
			this.statPage.pageNum = val;
			this.getStatList();
		},
		
		// ========== 钱包明细 ==========
		// 前一天/后一天（对齐提现统计的setDay）
		setDay(num) {
			const date = new Date();
			date.setDate(date.getDate() + num);
			const y = date.getFullYear();
			const m = (date.getMonth() + 1).toString().padStart(2, "0");
			const d = date.getDate().toString().padStart(2, "0");
			const dayStr = `${y}-${m}-${d}`;
			this.detailQuery.dateRange = [dayStr, dayStr];
		},
		setDay2(num) {
			// 1. 定义结束时间：今天
			const endDate = new Date();

			// 2. 定义开始时间：今天往前推 num 个月
			const startDate = new Date();

			console.log(endDate)
			console.log(startDate)
			
			// 使用 setMonth 而不是 setDate，因为 setDate 是按天数减，setMonth 是按月份减（更精准）
			startDate.setMonth(endDate.getMonth() - num);

			// 3. 封装一个格式化函数，避免重复代码
			const format = (date) => {
				const y = date.getFullYear();
				const m = (date.getMonth() + 1).toString().padStart(2, "0");
				const d = date.getDate().toString().padStart(2, "0");
				return `${y}-${m}-${d}`;
			};

    		// 4. 组装数组：[开始时间, 结束时间]
    		this.statQuery.dateRange = [format(startDate), format(endDate)];
		},
		// 重置明细查询条件（方法名对齐提现统计）
		resetDetailQuery() {
			this.detailQuery = {
				userName: '',
				phone: '',
				type: 'all',
				status: 'all',
				dateRange: "",
				minAmt: '',
				maxAmt: ''
			};
		},
		// 查询明细（核心：调用后台接口，对齐提现统计）
		async getDetailList() {
			try {
				// 封装查询参数
				const params = {
					// 分页参数（对齐提现统计）
					pageIndex: this.detailPage.pageNum,
					pageSize: this.detailPage.pageSize,
					// 基础查询条件
					nickName: this.detailQuery.userName.trim(),
					phoneNumber: this.detailQuery.phone.trim(),
					bizType: this.detailQuery.type !== 'all' ? this.detailQuery.type : undefined,
					status: this.detailQuery.status !== 'all' ? this.detailQuery.status : undefined,
					// 日期范围拆分
					startTime: this.detailQuery.dateRange ? this.detailQuery.dateRange[0] : '',
					endTime: this.detailQuery.dateRange ? this.detailQuery.dateRange[1] : '',
					// 金额范围
					startAmount: this.detailQuery.minAmt.trim()||'',
					endAmount: this.detailQuery.maxAmt.trim() || ''
				};
				
				// 调用钱包明细接口
				const res = await getWebUserQmxfWalletRecordsListPage(params);
				
				if (res.data.success) {
					this.detailList = res.data.response.data;
					this.detailTotal = res.data.response.dataCount;
					// this.$message.success("钱包明细查询成功");
				} else {
					this.$message.error(res.data.message || "钱包明细查询失败");
				}
			} catch (error) {
				console.error("钱包明细查询异常：", error);
				this.$message.error("网络异常，钱包明细查询失败");
			}
		},
		// 明细分页大小变化（对齐提现统计）
		detailSizeChange(val) {
			this.detailPage.pageSize = val;
			this.getDetailList();
		},
		// 明细分页页码变化（对齐提现统计）
		detailPageChange(val) {
			this.detailPage.pageNum = val;
			this.getDetailList();
		},
		
		// 查看统计详情（保留原有逻辑，可根据实际需求完善）
		viewStat(row) {
			console.log("查看统计详情：", row);
			// 可补充跳转/弹窗等逻辑
		}
	},
	created() {
		this.getStatList();
		this.setDay2(1)
		this.getWalletSummaryFun()
	}
};
</script>
<style scoped>
.withdraw-page {
	width: 98%;
	margin: 20px auto;
	padding: 20px;
	background: #fff;
	box-sizing: border-box;
}

.top-total {
	font-size: 14px;
	color: #333;
	margin-bottom: 15px;
}

.tab-box {
	margin-top: 5px;
}

.query-row {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 15px;
	flex-wrap: wrap;
}

.detail-query {
	padding: 10px;
	background: #f9f9f9;
	border-radius: 4px;
}

.query-item {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
	color: #666;
}

.time-box {
	gap: 8px;
}

.pager-box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 18px;
	font-size: 14px;
	color: #666;
}

/* 金额绿色高亮 */
.color-green {
	color: #00b42a;
	font-weight: 500;
	padding: 5px 10px;
	cursor: pointer;
}
.color-red {
	color: #ff0000;
	font-weight: 500;
	padding: 5px 10px;
}
</style>